export default "__VITE_ASSET__Cz$hoAzG__"